import React, { useEffect, useState } from "react";
import { oneKlicks } from "../../../SDK/oneclick";
import { getuserdata } from "../../../services/apiService";
import { toast } from "react-toastify";

const SecuritySettings = () => {
    const [isBlocked, setIsBlocked] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchUserStatus = async () => {
            try {
                const userId = await getuserdata('id');
                const tableSchema = "";
                const tableName = "users";
                const conditions = { id: userId };
                const orderBy = "";
                const search = "";
                const pagination = "";
                const margedata = "";
                const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
                
                if (response.data && response.data[0]) {
                    setIsBlocked(response.data[0]._profile_blocked === "on");
                }
            } catch (error) {
                console.error("Error fetching user status:", error);
                toast.error("Failed to fetch user status");
            }
        };
        fetchUserStatus();
    }, []);

    const handleStatusChange = async () => {
        try {
            setIsLoading(true);
            const newStatus = !isBlocked ? "on" : "off";
            const tableSchema = "";
            const tableName = "users";
            const data = {
                _profile_blocked: newStatus
            };
            const condition = {
                id: await getuserdata('id')
            };
            const response = await oneKlicks.update(tableSchema, tableName, data, condition);
            
            if (response.success) {
                if (newStatus === "on") {
                    toast.success('Account status Paused successfully');
                    setIsBlocked(!isBlocked);
                } else {
                    toast.success('Account status Resumed successfully');
                    setIsBlocked(!isBlocked);
                }
            } else {
                toast.error('Failed to update account status');
                // Keep the previous state if update fails
                setIsBlocked(isBlocked);
            }
        } catch (error) {
            console.error("Error updating user status:", error);
            toast.error("An error occurred while updating status");
            // Keep the previous state if update fails
            setIsBlocked(isBlocked);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-securityhold tab-pane active fade show" id="dc-security">
                <div className="dc-securitysettings dc-tabsinfo dc-tabsinfo-mt">
                    <div className="dc-tabscontenttitle">
                        <h3>Account Security &amp; Settings</h3>
                    </div>
                    <div className="dc-settingscontent dc-sidepadding">
                        <ul className="dc-accountinfo">
                            <li>
                                <div className="dc-on-off">
                                    <input 
                                        type="checkbox" 
                                        id="_profile_blocked" 
                                        checked={isBlocked}
                                        onChange={handleStatusChange}
                                        disabled={isLoading}
                                    />
                                    <label htmlFor="_profile_blocked"><i></i></label>
                                </div>
                                <span>Disable my account temporarily</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SecuritySettings;
